import EfbGreyLogo from "@/assets/icons/EfbGreyLogo";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { YourRightToKnow } from "@/types/about-us-page";
import React from "react";
import { useTranslation } from "react-i18next";

const YourRTK: React.FC<{ yourRightToKnow?: YourRightToKnow; isLoading: boolean }> = ({
  yourRightToKnow,
  isLoading,
}) => {
  const { t } = useTranslation();

  const handleNavigateToRTK = () => {
    window.location.href = "https://rtk.efb.eg/";
  };
  return (
    <section className="mx-6 my-16 flex flex-col-reverse gap-8 md:my-16 md:flex-row">
      <div className="aspect-square w-full flex-1 md:aspect-auto md:min-h-[684px]">
        {isLoading ? (
          <Skeleton className="h-full w-full rounded-lg bg-[#E2DDD7]" />
        ) : (
          <img
            className="h-full w-full rounded-lg object-cover object-center"
            src={yourRightToKnow?.image?.large_url}
            alt={t("aboutPage.rtkAltText")}
            loading="lazy"
          />
        )}
      </div>
      <div className="relative flex-1 overflow-hidden rounded-lg bg-[#E4E1D8]">
        <div className="mb-36 flex flex-col gap-y-8 p-4 md:px-6 md:py-[60px]">
          {isLoading ? (
            <>
              <Skeleton className="h-10 w-1/2 rounded bg-[#D6D3C9]" />
              <Skeleton className="h-48 w-full rounded bg-[#D6D3C9]" />
              <Skeleton className="h-12 w-1/3 rounded bg-[#D6D3C9]" />
            </>
          ) : (
            <>
              <h4 className="text-2xl font-semibold md:text-5xl">{yourRightToKnow?.title}</h4>
              <p className="whitespace-pre-line text-base md:text-2xl">
                {yourRightToKnow?.description}
              </p>

              <Button
                variant="default"
                size="lg"
                className="w-full md:w-fit"
                onClick={handleNavigateToRTK}
              >
                {t("aboutPage.visitRTKPage")}
              </Button>
            </>
          )}
        </div>
        <EfbGreyLogo className="absolute -bottom-6 right-6 h-[168px] w-[102px] md:h-[373px] md:w-[225px] " />
      </div>
    </section>
  );
};

export default YourRTK;
